import { makeAutoObservable } from 'mobx';
import goxApi from 'api/gox-api';
import AlertStore from './Alert';

class Auth {

  phone = null;
  phoneCountry = null;
  token = null;
  fetching = false;

  constructor() {
    makeAutoObservable(this);
  }

  async submitNumber(phone, phoneCountry) {
    try {
      this.setFetching(true);
      const response = await goxApi.submitNumber(phone, phoneCountry);
      this.applyData(response);
      this.setFetching(false);
    } catch (err) {
      AlertStore.add(err.message);
      this.setFetching(false);
    }
  }

  async submitCode(code) {
    try {
      this.setFetching(true);
      const { jwt } = await goxApi.submitCode(this.phone, this.phoneCountry, this.token, code);
      window.localStorage.setItem('token', jwt);
      this.setFetching(false);
    } catch (err) {
      AlertStore.add(err.message);
      this.setFetching(false);
    }
  }

  applyData(data) {
    this.phone = data.phone;
    this.phoneCountry = data.phone_country;
    this.token = data.token;
  }

  reset() {
    this.phone = null;
    this.phoneCountry = null;
    this.token = null;
  }

  setFetching(state = true) {
    this.fetching = state;
  }

  
   
}

const AuthStore = new Auth();
export default AuthStore;
